import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const Loader = ({ className, label }) => (
  <div className={cn("flex flex-col items-center justify-center gap-3 py-16 text-muted-foreground", className)}>
    <Loader2 className="h-6 w-6 animate-spin text-brand" />
    {label && <span className="text-sm">{label}</span>}
  </div>
);

export const SkeletonCard = () => (
  <div className="h-24 w-full animate-pulse rounded-xl border border-border bg-card" />
);
